module.exports = __webpack_public_path__ + "img/binzhou.6238dd3b.jpg";